<template>
  <aside class="sidebar" :class="{ 'sidebar--collapsed': collapsed }" aria-label="主菜单">
    <el-menu
      ref="menuRef"
      :default-active="activeMenu"
      class="sidebar-menu"
      :collapse="collapsed"
      :collapse-transition="false"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="item in menuItems"
        :key="item.path"
        :index="item.path"
        :aria-label="item.label"
      >
        <el-icon><component :is="item.icon" /></el-icon>
        <template #title><span>{{ item.label }}</span></template>
      </el-menu-item>
    </el-menu>
    <div class="sidebar__version">V1 试点版 · 0.1.0</div>
  </aside>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import type { MenuInstance } from "element-plus";
import { useNavigationItems } from "@/composables/useNavigationItems";
import type { WorkspaceTab } from "@/composables/useWorkspaceTabs";
const props = withDefaults(defineProps<{ collapsed?: boolean; tabs?: WorkspaceTab[] }>(), {
  collapsed: false,
  tabs: () => [],
});
const route = useRoute();
const router = useRouter();
const menuRef = ref<MenuInstance>();
const activeMenu = computed(() => [...menuItems.value]
  .sort((left, right) => right.path.length - left.path.length)
  .find((item) => route.path === item.path || route.path.startsWith(`${item.path}/`))?.path ?? route.path);
// router.onError reports the failure and offers recovery; consume the rejected
// promise here so Element Plus does not report it again as a component error.
const handleSelect = async (path: string) => {
  const target = props.tabs.find((tab) => tab.path === path)?.fullPath ?? path;
  await router.push(target).catch(() => undefined);
  menuRef.value?.updateActiveIndex(activeMenu.value);
};
const menuItems = useNavigationItems();
</script>
